<template>
  <header
    class="top between bg-slate-700 text-white bg-opacity-50 backdrop-blur-lg z-50"
  >
    <menu-app />
    <router-link to="/" class="font-medium tracking-widest uppercase"
      >gentleman</router-link
    >
    <svg-app @action="$router.push('/cart')" type="cart" theme="w-5" />
  </header>
</template>

<script>
import svgApp from "@/components/svgApp.vue";
import menuApp from "@/components/menuApp.vue";

export default {
  components: { svgApp, menuApp },
};
</script>
